import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserProjects } from '../../../Auth/Admin/utilities/adminUtils';
import { useAuth } from '../../../Auth/context/AuthContext';
import PageContainer from '../../../PageUtil/PageContainer';

const UserProjects = () => {
  const { isAdmin } = useAuth();
  const { userId } = useParams();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin) {
      loadProjects();
    } else {
      navigate('/dashboard');
    }
  }, [userId, navigate, isAdmin]);

  const loadProjects = async () => {
    setLoading(true);
    try {
      const data = await getUserProjects(userId);
      setProjects(data);
    } catch (err) {
      console.error('Error loading projects:', err);
      setError('Failed to load projects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer error={error} setError={setError} isAdmin={isAdmin}>
      <div className="py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h3 mb-0">Projects for User: {userId}</h1>
          <button className="btn btn-outline-secondary" onClick={() => navigate('/admin/users')}>
            <i className="bi bi-arrow-left me-2"></i>Back to Users
          </button>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row g-4">
            {projects.length > 0 ? projects.map(project => (
              <div key={project.id} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">{project.title}</h5>
                    <p className="card-text text-muted" style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}>
                      {project.overview}
                    </p>
                    <div className="mt-3">
                        <span className="badge bg-light text-dark border">
                            {project.images?.length || 0} Images
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            )) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted">This user has no projects.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default UserProjects;
